import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Box from 'components/Box';
import { H2 } from 'components/Heading';
import ModalBase, { CloseButton, Dialog } from 'modals/ModalBase';
import { breakpoints, colors } from 'theme';

const StyledDialog = styled(Dialog)<{ fullWidth?: boolean; wide?: boolean }>`
  background-image: linear-gradient(to left, #1d91e9, ${colors.niceBlue});
  background-size: 100% 7px;
  background-repeat: no-repeat;
  padding-top: 42px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 35px;
  ${(props) =>
    props.fullWidth &&
    `
    max-width: none;
  `}
  @media (min-width: ${breakpoints[2]}) {
    padding-top: 40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
    ${(props) => props.wide && `min-width: 650px`}
  }
`;
const StyledCloseButton = styled(CloseButton)`
  color: ${colors.battleshipGrey};
  &:hover {
    color: ${colors.waterBlue};
    &:disabled {
      &:hover {
        color: ${colors.battleshipGrey};
      }
    }
  }
`;
type Props = {
  children: ReactNode;
  className?: string;
  noCloseButton?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overlayComponent?: React.ComponentType<any>;
  title?: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose?: (...args: Array<any>) => any;
  'data-qa-id'?: string;
  wide?: boolean;
  fullWidth?: boolean;
};
export default class Modal extends React.PureComponent<Props> {
  get title() {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    return this.props.title ? (
      <H2 styleAs="h3" pb={2}>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/destructuring-assignment */}
        {this.props.title}
      </H2>
    ) : null;
  }

  render() {
    return (
      <ModalBase
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        className={this.props.className}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        onClose={this.props.onClose}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        overlayComponent={this.props.overlayComponent}
        renderDialog={(onDialogClick) => (
          <StyledDialog
            // @ts-expect-error Fix types
            onClick={onDialogClick}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            data-qa-id={this.props['data-qa-id']}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            wide={this.props.wide}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            fullWidth={this.props.fullWidth}
          >
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/destructuring-assignment */}
            {this.props.onClose && !this.props.noCloseButton && (
              <StyledCloseButton
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line react/destructuring-assignment
                onClick={this.props.onClose}
                data-qa-id="close-modal-button"
                data-modal-focus="false"
              />
            )}
            <Box>
              {this.title}
              {/* TODO: Fix this the next time the file is edited. */}
              {/* eslint-disable-next-line react/destructuring-assignment */}
              {this.props.children}
            </Box>
          </StyledDialog>
        )}
      />
    );
  }
}
